<template>
  <div id="summary-box">
    <div class="a">
      Afgang fra <b>{{fromAdresse}}</b> d. {{startDate}} <b>kl. {{startTime}}</b>
    </div>
    <div class="b">
      Ankomst til <b>{{toAdresse}}</b> d. {{endDate}} <b>kl. {{endTime}}</b>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import da from 'date-fns/locale/da';
import { getPlaceVejnavn } from '@/util';
export default {
  name: 'itinerary-summary',
  props: { itinerary: Object, fromPlace: Object, toPlace: Object },
  data: function() {
    return { getPlaceVejnavn };
  },
  computed: {
    fromAdresse: function() {
      return getPlaceVejnavn(this.fromPlace);
    },
    toAdresse: function() {
      return getPlaceVejnavn(this.toPlace);
    },
    startDate: function() {
      if (!this.itinerary) {
        return '';
      }
      return format(new Date(this.itinerary.startTime), 'Do MMMM YYYY', {
        locale: da,
      });
    },
    endDate: function() {
      if (!this.itinerary) {
        return '';
      }
      return format(new Date(this.itinerary.endTime), 'Do MMMM YYYY', {
        locale: da,
      });
    },
    startTime: function() {
      if (!this.itinerary) {
        return '';
      }
      return format(new Date(this.itinerary.startTime), 'HH:mm', {
        locale: da,
      });
    },
    endTime: function() {
      if (!this.itinerary) {
        return '';
      }
      return format(new Date(this.itinerary.endTime), 'HH:mm', { locale: da });
    },
  },
};
</script>

<style lang="scss" scoped>
#summary-box {
  padding: 44px 44px 0 44px;

  div {
    margin: 0 50px;
    padding: 12px 0 12px 45px;
    position: relative;
  }

  div:before {
    content: 'A';
    position: absolute;
    top: 11px;
    left: 0;
    background-color: $primary-700;
    color: #fff;
    height: 25px;
    width: 25px;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
  }
  .b:before {
    content: 'B';
  }
}

@media only screen and (max-width: $mobile-max-width) {
  #summary-box {
    padding: 30px 30px 0 30px;
    div {
      margin: 0;
      padding: 12px 0 12px 45px;
      position: relative;
    }
  }
}
</style>
